import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import LocalModal from 'components/base/local-modal';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

const RemoveVendorModal = ({ isOpen, onRequestClose }: Props) => {
  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentClassName='w-[80vw] max-w-[500px]'>
      <div className='p-6 flex flex-col justify-center items-center'>
        <ErrorIcon className='mb-3' />
        <h4 className='text-[24px] font-semibold text-[#2E3031] mb-4 text-center'>
          Are you sure you want to remove Femites Foodco ltd?
        </h4>
        <p className='text-sm text-[#6F7376] mb-6'>
          This will delete data associated with this vendor
        </p>
        <div className='flex gap-4 justify-center'>
          <Button
            variant='block'
            color='gray'
            onClick={onRequestClose}
            className='text-sm mr-4 hover:text-[#FF0000] transition duration-300 h-[41px] w-[139px] !bg-[#F2F2F2] !text-gray-6 !border-[#F2F2F2]'>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            onClick={onRequestClose}
            className='text-sm text-[#FF0000] hover:text-[#FF0000] transition duration-300 h-[41px] w-[139px]'>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default RemoveVendorModal;
